import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'redaction'
import { constants } from 'common/helpers'

import composeDialogModal from 'components/modals/DialogModal/composeDialogModal'

import messages from './messages'
import s from './SameFragranceErrorModal.scss'


const SameFragranceErrorModal = composeDialogModal({
  name: constants.modals.SameFragranceError,
  buttonTitle: messages.buttonTitle,
  contentMessage: ({ firstName }) => ({
    ...messages.text,
    values: { firstName },
    tag: 'span',
    className: s.text,
  }),
  propTypes: {
    firstName: PropTypes.string.isRequired,
  },
})


export default connect({
  firstName: 'models.me.firstName',
})(SameFragranceErrorModal)
